<template>
 <div>
  <div class="mian">
    <!-- 头部 -->
    <div class="top">
      <img src="../assets/images/头部信息框.png" alt="">
      <div class="info">
        <span>产品信息</span>
      </div>
      <div class=num>
        <span>01</span>
      </div>
    </div>
    <div class="product">
      <div class="text">
        <span class="text-top">Product picture</span>
        <span class="text-bottom">产·品·图·片</span>
      </div>
        <div class="picture">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for="(item, index) in list[0].op.op.picList" :key="index" @click="switch_image(item)">
                <img :src="item" alt="" class="img" style="width: 100%; height: 100%;">
              </van-swipe-item>
            </van-swipe>
      </div>
      
    </div>
    <div class="goodsInfo goodsInfo2">
          <div class="name goodsInfo-text" style="padding-bottom: 40px;">
           {{ list[0].op.op.product_name }}
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">
            净含量
          </div>
          <div class="goodsInfo-text-num texts">{{ list[0].op.op.weight }}{{ list[0].op.op.weightunit }}</div>
          </div>
          <!-- <div class="goodsInfo-text" v-if="infoList[0]">
            <div class="goods-title">
            零售价
          </div>
          <div class="goodsInfo-text-num texts">
            {{ infoList[0].op.op.price }}元
          </div>
          </div> -->
          <div class="goodsInfo-text">
            <div class="goods-title">
              所属品牌商
            </div>
            <div class="goodsInfo-text-num texts">
              {{ list[0].op.op.barand_name }}
            </div>
          </div>
          <div class="goodsInfo-text" v-for="(item, index) in newArr2" :key="index">
            <div class="goods-title">
              {{ item.key }}
            </div>
            <div class="goodsInfo-text-num texts">
              {{ item.value }}
            </div>
          </div>
      </div>
    <div class="goods-characteristic">
       <div class="goods-characteristic-inner">
           <span @click="toBlockChain">
              区块链标识：{{ list[0].txid }}</span>
        </div>
      </div>
      <div>
        <!-- <div class="material">
        <div class="dian">
          <div class="m-title">原料追溯</div>
        </div>
        <div class="date">
          {{ maList[0].ts | formant }}
        </div>
      </div> -->
      <!-- <div class="goodsInfo goodsInfo2">
          <div class="goodsInfo-text">
            <div class="goods-title">
              原料名称
          </div>
          <div class="goodsInfo-text-num texts">{{ maList[0].op.op.material_name }}</div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">
              所属产区
          </div>
          <div class="goodsInfo-text-num texts">
            {{ maList[0].op.op.produce_areaname }}
          </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">
              产地

            </div>
            <div class="goodsInfo-text-num texts">
              {{ maList[0].op.op.province }}{{ maList[0].op.op.city }}{{ maList[0].op.op.addressdetail || "" }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">
              种类
            </div>
            <div class="goodsInfo-text-num texts">
              {{ maList[0].op.op.speciesname }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">
              采摘年份
            </div>
            <div class="goodsInfo-text-num texts">
              {{ maList[0].op.op.yearname }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">
              地理位置
            </div>
            <div class="goodsInfo-text-num texts">
              
            </div>
          </div>
      </div> -->
      <!-- <div class="goods-characteristic">
       <div class="goods-characteristic-inner">
           <span @click="toBlockChain2">
              区块链标识：{{ maList[0].txid }}</span>
        </div>
      </div> -->
      </div>
      
  </div>
 </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
import { ImagePreview } from "vant";

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  data() {
    return {
      listDataAll: [],
      list: [],
      mList: [],
      materialData: [],
      maList: [],
      info: [],
      infoList: [],
      newArr: [],
      newArr2: []
    }
  },
  created() {
    this.listDataAll = JSON.parse(
      window.localStorage.getItem("defalutObj")
    )
    this.list = this.listDataAll.filter(item => item.trace_name === '商品信息')
    this.list.forEach(item => {
      this.list = item.msgItems
    })
    console.log('sp', this.list[0].op.op);
    localStorage.setItem("parameters", JSON.stringify(this.list[0].op.op.parameters))
    this.newArr = JSON.parse(window.localStorage.getItem('parameters'))
    this.newArr2 = JSON.parse(this.newArr)
    
    console.log(this.newArr);
    this.info = JSON.parse(
      window.localStorage.getItem("defalutObj")
    )
    this.infoList = this.info.filter(item => item.trace_name === '交易信息')
    this.infoList.forEach(item => {
      this.infoList = item.msgItems
    })
    
    this.materialData = JSON.parse(
      window.localStorage.getItem("idInObj")
    )
    this.newArr = Array.from(Object.values(this.materialData),x=>x);
    this.maList = this.newArr.filter(item => item.trace_name === '原料环节')
    this.maList.forEach(item => {
      this.maList = item.msgItems
    })
    
    console.log('zzzz', this.newArr);
  },
  mounted() {
  },
  methods: {
    toBlockChain() {
      this.$router.push(`/Look?ts=${this.list[0].ts}&txid=${this.list[0].txid}`);
    },
    toBlockChain2() {
      this.$router.push(`/Look?ts=${this.maList[0].ts}&txid=${this.maList[0].txid}`);
    },
    switch_image(img) {
      console.log(111);
      ImagePreview([img]);
    },
  }
}
</script>

<style lang="scss" scoped>
.mian {
  position: relative;
  width: 608px;
  margin-top: 10px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  margin-bottom: 20px;
  .top {
    position: relative;
    img {
    width: 100%;
   }
   .info {
    position: absolute;
    top: 9vw;
    left: 6vw;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 0px;
    color: #fff;
    opacity: 1;
   }
   .num {
    color: transparent;
    -webkit-text-stroke: 1px #127855;
    font-size: 11vw;
    position: absolute;
    top: 15px;
    left: 240px;
   }
  }
  .m-pic {
    margin: 40px auto;
  }
  .product {
    width: 550px;
    height: 746px;
    margin: 0 auto;
    border: #02B152 solid 10px;
    .text {
     display: flex;
     align-items: center;
     flex-direction: column;
     margin-right: 45px;
     margin-top: 50px;
     padding-top: 20px;
     .text-top {
      color: #007D5F;
      font-weight: bold;
      line-height: 0px;
      opacity: 1;
      font-size: 32px;
      margin-bottom: 30px;
     }
     .text-bottom {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #000000;
      opacity: 1;
      padding-top: 20px;
     }
    }
    .picture {
      
      border: 2px solid #707070;
      opacity: 1;
      border-radius: 0px;
      margin: 60px auto;
      width: 428px;
      height: 512px;
      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }
  }
  .goodsInfo2 {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #919AB1;
    opacity: 1;
  }
  .goodsInfo {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 544px;
      height: 404px;
      border: 2px solid #F3F3F3;
      opacity: 1;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 36px;
     .goodsInfo-text-num {
      white-space: pre-line;
      overflow: hidden;
      text-overflow: ellipsis;
     }
      .name {
        width: 376px;
        height: 40px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        opacity: 1;
      }
      .goodsInfo-text {
        .goods-title {
          width: 120px;
        }
        display: flex;
        margin-left: 20px;
    
      }
      .texts{
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        margin-left: 60px;
        color: #000000;
        opacity: 1;
      }
    }
  .goods-characteristic {
    width: 536px;
    margin: 0 auto;
    padding-bottom: 20px;
    .goods-characteristic-inner {
      
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .material {
    display: flex;
    justify-content: space-between;
    width: 548px;
    height: 49px;
    
    align-items: center;
    margin: 0 auto;
    border-bottom: 2px solid #E8E8E8;
    .dian {
      .m-title {
        width: 112px;
        height: 40px;
        font-weight: 400;
        line-height: 0px;
        margin-left: 15px;
        margin-top: 5px;
      }
      width: 12px;
      height: 12px;
      background: #000000;
      border-radius: 50%;
      opacity: 1;
      margin-right: -330px;
      font-size: 28px;
    }
    .date{
      
      width: 250px;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #919AB1;
      opacity: 1;
    }
  }
}
</style>